import React, { useRef, useState } from "react";
import { Button, TextField } from "@mui/material";
import lamp from '../Assets/Dewali_campaign/Lamp.png'
import Mresult from '../Assets/Dewali_campaign/M_result.png'
import { useNavigate } from "react-router-dom";
import  giftBoxes from '../Assets/Dewali_campaign/multiple_gift_box_small.png'
import { makeApiCallWithAuth } from "../Services/Api";

const OTP_Popup = ({ onOtpChange }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (value, index) => {
    if (!/^[0-9]*$/.test(value)) return; // allow only numbers

    const newOtp = [...otp];

    // If user pastes full OTP
    if (value.length > 1) {
      const chars = value.slice(0, otp.length).split("");
      for (let i = 0; i < chars.length; i++) {
        newOtp[i] = chars[i];
      }
      setOtp(newOtp);
      onOtpChange?.(newOtp.join(""));
      inputsRef.current[Math.min(chars.length - 1, otp.length - 1)].focus();
      return;
    }

    newOtp[index] = value;
    setOtp(newOtp);
    onOtpChange?.(newOtp.join(""));

    // Move to next input automatically
    if (value && index < otp.length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        // Clear current box only
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
        onOtpChange?.(newOtp.join(""));
      } else if (index > 0) {
        // Move to previous box
        inputsRef.current[index - 1]?.focus();
      }
    }
  };

  const handleCheckOtp = async() => {
     try {
        setLoading(true)
      const response = await makeApiCallWithAuth('checkOTP',{"otp":otp.join("")});
        const res = response.data
        console.log(res)
      if (res.status === 200 || res.status === 201) {
        navigate("/gift-selection-cake", {state: { statusstate : res.status}});
      }
      // else if (res.status === 201) {
      //   const response2 = await makeApiCallWithAuth('mailme',{
      //   // "brand":selectedBrand?.name,
      //   'productId':'',
      //   'productName':'',
      //   'productSku':''
      // });
      //   const res2 = response2?.data
      //   console.log(res?.data?.brand)
      //   if (res2.status === 200) {
      //       navigate('/purchase-details',{state:{selectedBrand:{name : res?.data?.brand}}})
      //   }else if (res2.status == 400){
      //   setError(res2.message)
      //   } 
      // }
      else if (res.status == 400){
        setError(res.message)
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      setError("Failed to submit. Please try again.");
      console.error(err);
    } finally {
        setLoading(false)
    }
  }

  return (
    <div className="fixed w-[350px] top-[10%] bg-white rounded-3xl shadow-lg p-6 text-center mx-auto mt-24">
       <img
          src={Mresult}
          alt="lamp"
          className="absolute -translate-x-1/2 left-1/2 top-[-80px] w-[60px] h-[60px] bg-white p-0.5  rounded-full"
        />
      <div className="flex justify-center items-center gap-2 mb-2">
        <img className="w-8" src={giftBoxes}></img>
        <h2 className="text-[#021555] font-bold text-lg">
          Claim Your Gift
        </h2>
        <img className="w-8 scale-x-[-1]" src={giftBoxes}></img>
      </div>

      <p className="text-dark font-medium text-sm mb-6">
        Enter the OTP sent to your email address
      </p>

      <p className=" text-left font-medium text-dark text-sm mb-1">
        Enter OTP 
      </p>
      <div className="flex justify-center gap-3 mb-6">
        {otp.map((digit, index) => (
          <TextField
            key={index}
            variant="outlined"
            size="small"
            value={digit}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            inputRef={(el) => (inputsRef.current[index] = el)}
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "18px",
                width: "40px",
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            "& fieldset": {
                borderColor: "#EA6D58",
            },
            "&:hover fieldset": {
                borderColor: "#EA6D58", 
            },
            "&.Mui-focused fieldset": {
                borderColor: "#EA6D58", 
            },
            }}
          />
        ))}
      </div>
      {error && (
              <p className="text-red-500 text-xs mb-3 -mt-3 text-left">{error}</p>
            )}

      <Button
        fullWidth
        variant="contained"
        disabled={loading}
        sx={{
          backgroundColor: "#0D0E2E",
          borderRadius: "100px",
          textTransform: "none",
          py: 1.2,
          fontWeight: "bold",
          "&:hover": { backgroundColor: "#15163F" },
        }}
        onClick={() => {handleCheckOtp();}}
      >
        {loading ? (
        <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
        ) : (
        'Verify & Continue'
        )}
      </Button>

      <button onClick={()=>navigate('/')} className="text-[#E59F37] text-sm mt-3 font-medium">
        Change details
      </button>

      {/* <img
        src={lamp}
        alt="lamp"
        className="absolute bottom-[-60px] left-[10%] w-[60px]"
      />
      <img
        src={lamp}
        alt="lamp"
        className="absolute bottom-[-60px] right-[10%] w-[60px]"
      /> */}

    </div>
  );
};

export default OTP_Popup;
